import { Sidebar, Menu, MenuItemLink, getResources } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import DefaultIcon from "@material-ui/icons/ViewList";

import SettingsIcon from "@material-ui/icons/Settings";

import "../../common/css/paku-app.css";

const useSidebarStyles = makeStyles({
  drawerPaper: {
    backgroundColor: "#f8f9fa",
    boxShadow: "0 -1px 2px 0 #dfe3ec",
    lineHeight: "2.5rem",
    marginRight: "2rem",
    // borderRight: '1px dashed rgba(145, 158, 171, 0.24)',
    // borderRightWidth: '1px',
    // borderRightStyle: 'dashed',
    // borderRightColor: 'rgba(145, 158, 171, 0.24)',
  },
});

const MySidebar = (props) => {
  const classes = useSidebarStyles();
  const resources = useSelector(getResources);
  const open = useSelector((state) => state.admin.ui.sidebarOpen);

  return (
    <Sidebar classes={classes} {...props}>
      <Menu {...props}>
        {/* <div
          className="sidebarSubTitle"
          style={{ visibility: open ? "visible" : "hidden" }}
        >
          ANALYTICS
        </div> */}

        {resources
          .filter((resource) => resource.options.menuParent === "analytics")
          .map((resource) => (
            <MenuItemLink
              className="menuItemLink"
              key={resource.name}
              to={`/${resource.name}`}
              primaryText={
                (resource.options && resource.options.label) || resource.name
              }
              leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
              onClick={props.onMenuClick}
              sidebarIsOpen={open}
            />
          ))}

        <div
          className="sidebarSubTitle"
          style={{ visibility: open ? "visible" : "hidden" }}
        >
          GENERAL
        </div>

        {resources
          .filter((resource) => resource.options.menuParent === "general")
          .map((resource) => (
            <MenuItemLink
              className="menuItemLink"
              key={resource.name}
              to={`/${resource.name}`}
              primaryText={
                (resource.options && resource.options.label) || resource.name
              }
              leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
              onClick={props.onMenuClick}
              sidebarIsOpen={open}
            />
          ))}
        <div
          className="sidebarSubTitle"
          style={{ visibility: open ? "visible" : "hidden" }}
        >
          MAINTENCE
        </div>
        {resources
          .filter((resource) => resource.options.menuParent === "maintence")
          .map((resource) => (
            <MenuItemLink
              className="menuItemLink"
              key={resource.name}
              to={`/${resource.name}`}
              primaryText={
                (resource.options && resource.options.label) || resource.name
              }
              leftIcon={resource.icon ? <resource.icon /> : <SettingsIcon />}
              onClick={props.onMenuClick}
              sidebarIsOpen={open}
            />
          ))}
        <div
          className="sidebarSubTitle"
          style={{ visibility: open ? "visible" : "hidden" }}
        >
          BETA
        </div>
         <MenuItemLink
          to={`/upload-file`}
          primaryText={"Upload file"}
          leftIcon={<SettingsIcon />}
          sidebarIsOpen={open}
        />
        {resources
          .filter((resource) => resource.options.menuParent === "beta")
          .map((resource) => (
            <MenuItemLink
              className="menuItemLink"
              key={resource.name}
              to={`/${resource.name}`}
              primaryText={
                (resource.options && resource.options.label) || resource.name
              }
              leftIcon={resource.icon ? <resource.icon /> : <SettingsIcon />}
              onClick={props.onMenuClick}
              sidebarIsOpen={open}
            />
          ))}
        <div
          className="sidebarSubTitle"
          style={{ visibility: open ? "visible" : "hidden" }}
        >
          REPORTS
        </div>
        {resources
          .filter((resource) => resource.options.menuParent === "reports")
          .map((resource) => (
            <MenuItemLink
              className="menuItemLink"
              key={resource.name}
              to={`/${resource.name}`}
              primaryText={
                (resource.options && resource.options.label) || resource.name
              }
              leftIcon={resource.icon ? <resource.icon /> : <SettingsIcon />}
              onClick={props.onMenuClick}
              sidebarIsOpen={open}
            />
          ))}
      </Menu>
    </Sidebar>
  );
};

export default MySidebar;
